import React from 'react';
import BubbleChart from './BubblesNivo';
import config from '../config';

interface IResultsBubbles {
  scores: any;
}

const ResultsBubbles: React.SFC<IResultsBubbles> = props => {
  const { scores } = props;

  const scoresCount = Object.keys(scores).reduce(
    (prev: any, curr: any): any => {
      const score = scores[curr];
      const counter = prev;

      counter[score] = counter[score] ? counter[score] + 1 : 1;

      return counter;
    },
    {}
  );

  const dataChildren = Object.keys(scoresCount).map((scores: any) => {
    return {
      name: config.formScale[scores].shortName,
      color: config.formScale[scores].color,
      count: scoresCount[scores],
      score: scores
    };
  });

  const data = {
    name: 'stack',
    children: dataChildren
  };

  return <BubbleChart data={data} />;
};

export default ResultsBubbles;
